import styled, { css } from "styled-components";

type Variant = "primary" | "secondary";

const variants: Record<Variant, ReturnType<typeof css>> = {
  primary: css`
    background: var(--color-primary);
    color: #fff;
    &:hover:not(:disabled) {
      background: var(--color-primary-dark);
    }
  `,
  secondary: css`
    background: var(--color-accent);
    color: #fff;
    &:hover:not(:disabled) {
      background: #b45309;
    }
  `,
};

const Button = styled.button<{ variant?: Variant }>`
  display: inline-block;
  border: none;
  border-radius: 6px;
  padding: 0.7rem 1.4rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
  text-decoration: none;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  ${({ variant = "primary" }) => variants[variant]}
`;

export default Button;
